<template>
  <div v-if="isCurrentGNB('poll/issue')" :class="{poll_ctnr: isCurrentGNB('poll/issue')}">
    <div class="p_ctnr_inner">
      <!--<div v-html="post.title" class="date"></div>-->
      <p v-for="(tag, i) in post.tags" :key="i" class="date">{{tag}}</p>
      <p v-html="post.contents"></p>
      <a @click="copyURL" ref="mylink" class="get-url"><img src="https://api.card-gorilla.com:8080/storage/corp/2/tips/29439/tips_icon_link.png"></a>
    </div>
  </div>
  <div v-else-if="post.idx" class="post-container-wrap">
    <a href="javascript:" @click="goDetail(post)" class="post-container">
      <p class="img"><img v-if="isFileExist(post.post_img)" :src="post.post_img.url" class="fit_img"></p>
      <p class="category" :style="`color: ${post.post_cate_color}`">{{post.post_cate_txt}}</p>
      <p class="subj">{{post.title}}</p>
    </a>
<!--    <a @click="copyURL" ref="mylink">aaaa</a>-->
<!--    <div class="post-container full-width">-->
<!--      <router-link :to="`/article/${post.idx}`" class="img">-->
<!--        <img :src="getFileExist(post.post_img)" class="fit_img">-->
<!--      </router-link>-->
<!--      <div class="data">-->
<!--        <router-link :to="`/news/cate/${post.post_cate}`" class="category" :style="post.post_cate_color ? `color: ${post.post_cate_color}` : null">{{post.post_cate_txt}}</router-link>-->
<!--        <router-link :to="`/article/${post.idx}`" class="subj">-->
<!--          {{post.title}}-->
<!--        </router-link>-->
<!--        <p class="date_area">-->
<!--          <i class="date">{{post.reg_dt}}</i>-->
<!--          <i class="writer">{{getWriterNick}}</i>-->
<!--          <i class="writer_img"><img v-if="post.writer" :src="getFileExist(post.writer.prof_img)" width="30" height="30"></i>-->
<!--        </p>-->
<!--        <p class="con">-->
<!--          {{getTextCroped(removeFroalaAlertText(post.contents), 90, '...')}}-->
<!--        </p>-->
<!--        <div class="hv">-->
<!--          <p class="h_tags" v-if="post.tags && post.tags.length > 0">-->
<!--            <router-link :to="`/news/tag/${tag}`" v-for="(tag, index) in post.tags" :key="index">{{tag}}</router-link>-->
<!--          </p>-->
<!--          &lt;!&ndash;<p class="view"><i>{{post.view_cnt}}</i> views</p>&ndash;&gt;-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->


    <!-- Gallery Modal -->
    <q-dialog ref="galleryModal" :no-route-dismiss="true">
      <div class="gallery_pop">
        <div class="dark_bg" @click="$refs.galleryModal.hide()"></div>
        <transition name="el-fade-in-linear">
          <div v-if="isModalInnerBox">
            <a class="close_btn" @click="$refs.galleryModal.hide()"></a>
            <div class="album_ctnr">
              <div class="img">
                <div class="img_wrap">
                  <img v-if="isFileExist(post.post_img) && isModalInnerBox" :src="post.post_img.url" @click="show(post)">
                  <a class="download" :href="download"></a>
                </div>
              </div>
              <div class="article">
                <transition name="el-fade-in-linear">
                  <div v-if="isModalInnerBox">
                    <p class="subj">{{ post.title }}</p>
                    <p class="tag" v-if="post.tags">
                      <router-link :to="`/article/tag/${tag}`" v-for="(tag, i) in post.tags" :key="i">{{tag}}</router-link>
                    </p>
                    <p class="series">{{post.series_title}}<em>&gt;</em>{{post.album_title}}</p>
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </q-dialog>

    <!-- Market Modal (PC)-->
    <q-dialog ref="modal" :no-route-dismiss="true" v-if="!isMobile">
      <div class="insta_pop">
        <a class="close_btn" @click="$refs.modal.hide()"></a>
        <div class="insta_ctnr">
          <div class="img">
            <transition name="el-fade-in-linear">
              <img v-if="isModalInnerBox" :src="getFileExist(post.post_img)">
            </transition>
          </div>
          <div class="article">
            <div class="logo">
              <span><img src="/statics/img/bi_origin.png"></span>
              <p>bluffandcatch</p>
            </div>
            <transition name="el-fade-in-linear">
              <div v-if="isModalInnerBox">
                <p class="subj">{{ post.title }}</p>
                <p class="con" v-html="post.contents"></p>
                <p class="tag" v-if="post.tags">
                  <i>TAGs</i>
                  <router-link :to="`/article/tag/${tag}`" v-for="(tag, i) in post.tags" :key="i">{{tag}}</router-link>
                </p>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </q-dialog>

    <!-- Market Modal (Mobile)-->
    <q-dialog ref="modal" :no-route-dismiss="true" v-if="isMobile">
      <a class="close_btn" @click="$refs.modal.hide()"></a>
      <div class="insta_ctnr">
        <div class="logo">
          <span><img src="/statics/img/bi_origin.png"></span>
          <p>bluffandcatch</p>
        </div>
        <div class="img">
          <transition name="el-fade-in-linear">
            <img v-if="isFileExist(post.post_img)" :src="getFileExist(post.post_img)" />
          </transition>
        </div>
        <div class="article">
          <p class="subj">{{ post.title }}</p>
          <p class="con" v-html="post.contents"></p>
          <p class="tag" v-if="post.tags">
            <i>TAGs</i>
            <router-link :to="`/article/tag/${tag}`" v-for="(tag, i) in post.tags" :key="i">{{tag}}</router-link>
          </p>
        </div>
      </div>
    </q-dialog>

  </div>
</template>

<script>
  import { QDialog } from 'quasar'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import CommonMethods from 'src/_mixins/CommonMethods'
  import Vue from "vue";
  export default {
    name: 'PostContainer',
    components: {
      QDialog,
    },
    props: {
      post: {
        default: {}
      }
    },
    data () {
      return {
        isModalInnerBox: true,
      }
    },
    computed: {
      ...CommonComputed,
      getWriterNick () {
        return this.post.writer ? this.post.writer.nick : this.post.writer_nick ? this.post.writer_nick : this.getAppName
      },
      getAccess () {
        return 'pc'
      },
      isMobile () {
        return this.getAccess === 'mobile'
      },
      download () {
        return Vue.prototype.$apiURL + '/album_images/download/' + this.post.idx
      }
    },
    methods: {
      ...CommonMethods,
			copyURL() {
				const el = document.createElement('textarea');
				el.value = window.location.origin + this.post.link_detail;
				el.setAttribute('readonly', '');
				el.style.position = 'absolute';
				el.style.left = '-9999px';
				document.body.appendChild(el);
				const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;
				el.select();
				document.execCommand('copy');
				document.body.removeChild(el);
				if (selected) {
					document.getSelection().removeAllRanges();
					document.getSelection().addRange(selected);
				}
				alert('URL이 복사되었습니다.');
			},
      goDetail (post) {
        if (post.post_cate_txt === 'MARKET') {
          this.isModalInnerBox = false
          this.$refs.modal.show()
          setTimeout(() => this.isModalInnerBox = true, 200)
        } else if (post.post_cate_txt === 'GALLERY') {
          this.isModalInnerBox = false
          this.$refs.galleryModal.show()
          setTimeout(() => this.isModalInnerBox = true, 200)
        } else {
          this.$router.push(post.link_detail)
        }
      },
      show (post) {
        if (this.isMobile) {
          const $this = this
          const $viewer = this.$viewerApi({
            images: [post.post_img.url],
            options: {
              show(event) {
                $this.isModalInnerBox = false
              },
              hide(event) {
                $this.isModalInnerBox = true
              }
            }
          })
        }
      },
      isCurrentGNB (name) {
        return this.$route.path.indexOf(name) > -1
      },
    }
  }
</script>

<style scoped>
  .post-container .img {
    position: relative;
    height: 190px;
    border-radius: 8px;
    overflow: hidden;
  }
  .post-container .category {
    font-size: 14px;
    font-weight: 500;
    color: #368ee9;
    line-height: 1.0em;
    margin-top: 20px;
  }
  .post-container .subj {
    font-size: 17px;
    font-weight: 600;
    color: #000;
    line-height: 1.35em;
    word-break: normal;
    margin-top: 12px;
    max-height: 3.9em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  /* gallery modal */
  .gallery_pop {
    max-width: unset;
    height: auto;
    max-height: unset;
    overflow: visible;
  }
  .gallery_pop .dark_bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.8);
  }
  .gallery_pop .close_btn {
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
    width: 40px;
    height: 40px;
    z-index: 1;
  }
  .gallery_pop .close_btn:before {
    content: "×";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-48%, -54%);
    font-size: 40px;
    font-weight: 300;
    color: #00ff64;
  }
  .gallery_pop .close_btn:hover:before {
    color: #fff;
  }
  .gallery_pop .album_ctnr {
    width: 100%;
    height: 100%;
    text-align: center;
  }
  .gallery_pop .album_ctnr .img {
    align-items: center;
    position: relative;
  }
  .gallery_pop .album_ctnr .img .img_wrap {
    display: inline-block;
  }
  .gallery_pop .album_ctnr .img .img_wrap .download {
    position: absolute;
    bottom: 0;
    margin-left: 20px;
    display: inline-block;
    width: 50px;
    height: 50px;
    border-radius: 5.0em;
    border: 1px solid rgba(255,255,255,0.35);
    background-image: url('/statics/img/icon_download.png');
    background-size: 45%;
    background-repeat: no-repeat;
    background-position: 50% 48%;
    cursor: pointer;
  }
  .gallery_pop .album_ctnr .img .img_wrap .download:hover {
    border: 1px solid rgba(255,255,255,0.75);
  }
  .gallery_pop .album_ctnr .img img {
    max-width: 82vw;
    max-height: 82vh;
  }
  .gallery_pop .album_ctnr .article {
    position: relative;
    padding: 10px;
    word-break: normal;
    color: #fff;
  }
  .gallery_pop .album_ctnr .article .subj {
    font-size: 1.6em;
    font-weight: 700;
    letter-spacing: -0.02em;
    padding: 5px 0;
  }
  .gallery_pop .album_ctnr .article .tag a {
    display: inline-block;
    margin-right: 10px;
    line-height: 1.6em;
    font-size: 1.1em;
    font-weight: 300;
    color: #00ff64;
  }
  .gallery_pop .album_ctnr .article .tag a:before {
    content: "#";
  }
  .gallery_pop .album_ctnr .article .tag a:hover {
    color: #fff;
  }
  .gallery_pop .album_ctnr .article .series {
    color: rgba(255,255,255,0.75);
    line-height: 1.0em;
    padding-top: 5px;
  }
  .gallery_pop .album_ctnr .article .series em {
    font-style: normal;
    font-size: 0.6em;
    color: rgba(255,255,255,0.5);
    padding: 0 10px;
  }
  .gallery_pop .arrows {
    position: absolute;
    top: 50%;
    left: 50%;
    display: block;
    width: 96vw;
    height: 50px;
    transform: translate(-50%, -50%);
    z-index: 99;
  }
  .gallery_pop .arrows p {
    display: inline-block;
    width: 50px;
    height: 50px;
    background: rgba(0,0,0,0.5);
    border-radius: 100%;
    position: relative;
    cursor: pointer;
  }
  .gallery_pop .arrows p:before {
    content: "";
    display: inline-block;
    width: 16px;
    height: 16px;
    border: #fff solid;
    border-width: 2px 2px 0 0;
    position: absolute;
    top: 50%;
    left: 44%;
    transform: translate(-50%, -50%) rotate(45deg);
  }
  .gallery_pop .arrows p.prev:before {
    border-width: 0 0 2px 2px;
    left: 56%;
  }
  .gallery_pop .arrows p.next {
    float: right;
  }
  .gallery_pop .arrows p:hover {
    background: rgba(0,0,0,0.8);
  }

  /* market modal (PC) */
  .insta_pop {
    max-width: 85vw;
    height: auto;
    max-height: 90vh;
    overflow: hidden;
  }
  .insta_pop .close_btn {
    position: absolute;
    top: 15px;
    right: 15px;
    /*background: rgba(0,0,0,0.6);
    border-radius: 100%;*/
    cursor: pointer;
    width: 40px;
    height: 40px;
    z-index: 1;
  }
  .insta_pop .close_btn:before {
    content: "×";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-48%, -54%);
    font-size: 40px;
    font-weight: 300;
    color: #00ff64;
  }
  .insta_pop .close_btn:hover:before {
    color: #fff;
  }
  .insta_pop .insta_ctnr {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    flex-direction: row;
  }
  .insta_pop .insta_ctnr .img {
    width: 90vh;
    height: 90vh;
    display: flex;
    align-items: center;
    background: #000;
    position: relative;
  }
  .insta_pop .insta_ctnr .img img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
  .insta_pop .insta_ctnr .article {
    position: relative;
    width: 48vh;
    max-width: 450px;
    height: 90vh;
    padding: 25px;
    word-break: normal;
    overflow-y: auto;
  }
  .insta_pop .insta_ctnr .article .logo {
    padding: 0 0 20px 0;
    border-bottom: 1px solid #ddd;
  }
  .insta_pop .insta_ctnr .article .logo span {
    display: inline-block;
    width: 40px;
    height: 40px;
    background: #000;
    padding: 5px 6px;
    border-radius: 100%;
  }
  .insta_pop .insta_ctnr .article .logo span img {
    width: 100%;
  }
  .insta_pop .insta_ctnr .article .logo p {
    display: inline-block;
    font-size: 1.2em;
    font-weight: 900;
    line-height: 40px;
    margin-left: 10px;
  }
  .insta_pop .insta_ctnr .article .subj {
    font-size: 1.75em;
    font-weight: 900;
    letter-spacing: -0.02em;
    padding: 20px 0;
  }
  .insta_pop .insta_ctnr .article .con {
    font-size: 1.15em;
    font-weight: 400;
    padding-bottom: 40px;
    line-height: 1.4em;
  }
  .insta_pop .insta_ctnr .article .tag {
    /*position: absolute;
    bottom: 5%;
    width: calc(100% - 50px);*/
  }
  .insta_pop .insta_ctnr .article .tag i {
    display: block;
    font-size: 1.15em;
    font-weight: 700;
    padding-bottom: 10px;
  }
  .insta_pop .insta_ctnr .article .tag a {
    display: inline-block;
    margin-right: 10px;
    line-height: 1.6em;
    font-size: 1.10em;
    font-weight: 400;
    color: #379339;
  }
  .insta_pop .insta_ctnr .article .tag a:before {
    content: "#";
  }
  .insta_pop .insta_ctnr .article .tag a:hover {
    color: #000;
  }
  .insta_pop .arrows {
    position: absolute;
    top: 50%;
    left: 50%;
    display: block;
    width: 96vw;
    height: 50px;
    transform: translate(-50%, -50%);
  }
  .insta_pop .arrows p {
    display: inline-block;
    width: 50px;
    height: 50px;
    background: rgba(0,0,0,0.5);
    border-radius: 100%;
    position: relative;
    cursor: pointer;
  }
  .insta_pop .arrows p:before {
    content: "";
    display: inline-block;
    width: 16px;
    height: 16px;
    border: #fff solid;
    border-width: 2px 2px 0 0;
    position: absolute;
    top: 50%;
    left: 44%;
    transform: translate(-50%, -50%) rotate(45deg);
  }
  .insta_pop .arrows p.prev:before {
    border-width: 0 0 2px 2px;
    left: 56%;
  }
  .insta_pop .arrows p.next {
    float: right;
  }
  .insta_pop .arrows p:hover {
    background: rgba(0,0,0,0.8);
  }
  .p_ctnr_inner {
    position: relative;
  }
  .p_ctnr_inner .date {
    font-size: 14px;
    font-weight: 500;
    color: #666;
    line-height: 1.0em;
    margin-bottom: 40px;
  }
  .p_ctnr_inner .date:before {
    content: "Period";
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    padding: 6px 14px;
    background: #000;
    border-radius: 0.3em;
    margin-right: 12px;
    line-height: 1.0em;
  }
  .p_ctnr_inner .get-url {
    position: absolute;
    top: -10px;
    right: 0;
    padding: 6px;
    border: 2px solid #ddd;
    border-radius: 7px;
    overflow: hidden;
    cursor: pointer;
  }
  .p_ctnr_inner .get-url img {
    width: 18px;
    filter: opacity(0.5);
  }
  .p_ctnr_inner .get-url:hover img {
    filter: opacity(1.0);
  }
  /deep/ .p_ctnr_inner .os_poll {
    top: -40px;
    margin-bottom: -40px;
  }

  /deep/ .fr-video { display: block !important; position: relative !important; height: 0 !important; padding-bottom: 56.25% !important; }
  /deep/ .fr-video iframe { position: absolute !important; width: 100% !important; height: 100% !important; top:0; left: 0; }
  /deep/ [data-f-id="pbf"] {
    display: none;
  }
</style>
